import { HttpEmployerService } from './../../../service/http-employer.service';
import { Component } from '@angular/core';
import { DynamicFormDto } from '../../../service/dto';
import { ActivatedRoute, Router } from '@angular/router';
import { FormResult } from '../../../components/dynamic-form/dynamic-form.component';

@Component({
  selector: 'app-employer-form',
  standalone: false,
  templateUrl: './employer-form.component.html',
  styleUrl: './employer-form.component.scss'
})
export class EmployerFormComponent {
	data?: DynamicFormDto;

	constructor(
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private httpService: HttpEmployerService) { }

	ngOnInit(): void {
		const id = this.activatedRoute.paramMap.subscribe(paramMap => {
			const id = paramMap.get('id');
			if (id) {
				this.httpService.get(+id).subscribe(result => {
					this.data = result;
				});
			} else {
				this.httpService.getForm().subscribe(result => {
					this.data = result;
				});
			}
		});
	}
	doHandleResult(input: FormResult){
		if(input.type == 'Cancel'){
			this.router.navigate(['/employer','list']);
			return;
		}
		(this.data?.id ? (this.httpService.edit(this.data.id, input.data)) : (this.httpService.create(input.data))).subscribe(result => {
			this.router.navigate(['/employer','list']);
		});
	}
}
